import * as AuthActionCreators from './auth/actions';
import * as ItemActionCreators from './items/actions';
import * as RegisterActionCreators from './register/actions';
import * as UserActionCreators from './user/actions';
import * as UsersActionCreators from './users/actions';
import * as GlobalActionCreators from './global/actions';

export const allActionCreators = {
  ...AuthActionCreators,
  ...GlobalActionCreators,
  ...ItemActionCreators,
  ...RegisterActionCreators,
  ...UserActionCreators,
  ...UsersActionCreators,
};
